export default class UTM {
    selectors = {
        links: "a[href*='http']:not([href*='onlinelibrary']):not([href*='ciplit']):not([href*='literatumonline']):not([href*='facebook']):not([href*='instagram']):not([href*='linkedin']):not([href*='twitter'])",
        metaTag: 'meta[name=submission-systems-domains]',
    };

    elements = {
        links: null,
        metaTag: null,
    };

    variables = {
        utmParamsObj: {},
        utmParamsStr: '',
        fileContent: [],
    };

    constructor() {
        if (window.utmParamsEnabled) {
            this.setElements();
            this.init();
        }
    }

    setElements() {
        this.elements.links = Array.from(document.querySelectorAll(this.selectors.links));
        this.elements.metaTag = document.querySelector(this.selectors.metaTag);
    }

    async init() {
        let url = new URL(window.location.href),
            submissionDomains = await this.fetchData(),
            passParams = false,
            cookieResponse = UX.utils.getCookie('utm_params_persistence');

        UX.utils.deleteCookie('s_utm_cmp', '/');

        if (url.href.includes('utm')) {
            this.utmParams(url);
            UX.utils.setCookie('utm_params_persistence', this.variables.utmParamsStr);
            passParams = true;
        } else if (cookieResponse) {
            url.search = cookieResponse;
            passParams = true;
        }

        if (passParams) {
            this.addParams(url, submissionDomains);
        }
    }

    addParams(url, submissionDomains) {
        let href = '',
            submissionLink = '',
            hostName = '';

        this.elements.links.forEach(link => {
            href = link.getAttribute('href');

            submissionLink = href.startsWith('/') ? new URL(href, url) : new URL(href);
            hostName = submissionLink.hostname;

            if (hostName.startsWith('www')) {
                hostName = hostName.replace('www.', '');
            }

            if (submissionDomains?.includes(hostName)) {
                if (submissionLink.searchParams.toString().length < 3) {
                    submissionLink.search = url.searchParams.toString();
                    link.setAttribute('href', submissionLink.href);
                } else {
                    this.setParams(submissionLink);
                    link.setAttribute('href', submissionLink.href);
                }
            }
        });
    }

    setParams(url) {
        for (const key in this.variables.utmParamsObj) {
            url.searchParams.set(key, this.variables.utmParamsObj[key]);
        }
    }

    utmParams(url) {
        this.variables.utmParamsStr = '';
        this.variables.utmParamsObj = {};

        url.searchParams.forEach((value, key) => {
            if (key.includes('utm')) {
                let storedValue = value.slice(0, 50);

                this.variables.utmParamsObj[key] = storedValue;
                this.variables.utmParamsStr += `${key}=${storedValue}&`;
            }
        });

        this.variables.utmParamsStr = this.variables.utmParamsStr.slice(0, -1);
    }

    async fetchData() {
        const url = this.elements.metaTag?.getAttribute('content');

        if (url) {
            const fileContent = await UX.utils.readFromFile(url);
            return fileContent.split('\n');
        }
    }
}
